import Vue from 'vue'
import Vuex from 'vuex'
import Setting from './Setting/index'
import Ecommerce from './Ecommerce/index'
import User from './User/index'
import forgotpasswordStep1 from './forgotpasswordStep1/index'
import { permissionsStore } from './permissionsStore'
import sidebar from './sidebar'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    Setting,
    Ecommerce,
    User,
    forgotpasswordStep1
  },
  state: {
    ...permissionsStore.state,
    ...sidebar.state,
  },
  mutations: {
    ...permissionsStore.mutations,
    ...sidebar.mutations,
  },
  actions: {
    
  },
  getters: {
  },
  strict: debug
})
